import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  funderprofile,
  funderreportcreate,
  funderreportdetail,
  funderreportlist,
  funderreportpublish,
  funderreportupdate,
} from "../../../../services/funder";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import Swal from "sweetalert2";
import { funderdetail } from "../../../../services/master";
import {
  scheadreportlist,
  schprofileview,
} from "../../../../services/schoolhead";
import { managerreportlist } from "../../../../services/cityregionaladmin";

export const FunderReport = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [rtitle, setRTitle] = useState("");
  const [rdesc, setRDesc] = useState("");
  const [rfile, setRFile] = useState("");
  const [rpath, setRPath] = useState("");
  const [repid, setRepId] = useState("");
  const [repformat, setRepFormat] = useState("");

  const [funname, setFunName] = useState("");
  const [funid, setFunId] = useState("");

  const columnDefs = [
    // {
    //   headerName: "Actions",
    //   width: 100,
    //   field: "id",
    //   resizable: true,
    //   filter: false,
    //   cellRenderer: function (params) {
    //     return (
    //       <div className="text-center">
    //         <a
    //           onClick={() => addlist(params)}
    //           title="Edit Report"
    //           className="btn-sm btn-info"
    //         >
    //           <i className="fa fa-edit fa-lg"></i>
    //         </a>
    //       </div>
    //     );
    //   },
    // },
    {
      headerName: "Publish Status",
      width: 130,
      field: "selected_status",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => repstatus(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Report Status",
      field: "publish_status_new",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Tag",
      field: "tag_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Remark",
      field: "remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "File",
      field: "file_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              {params.data.file_or_url == "url" && (
                <a href={params.value} target="_blank">
                  Click Here
                </a>
              )}
              {params.data.file_or_url != "url" && (
                <a href={rpath + params.value} target="_blank">
                  Click Here
                </a>
              )}
            </div>
          );
        } else {
          return <div className="text-center">-</div>;
        }
      },
    },
  ];

  const columnFDefs = [
    // {
    //   headerName: "Actions",
    //   width: 100,
    //   field: "id",
    //   resizable: true,
    //   filter: false,
    //   cellRenderer: function (params) {
    //     return (
    //       <div className="text-center">
    //         <a
    //           onClick={() => addlist(params)}
    //           title="Edit Report"
    //           className="btn-sm btn-info"
    //         >
    //           <i className="fa fa-edit fa-lg"></i>
    //         </a>
    //       </div>
    //     );
    //   },
    // },
    {
      headerName: "Publish Status",
      width: 130,
      field: "selected_status",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => repstatus(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Report Status",
      field: "publish_status_new",
      width: 150,

      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Tag",
      field: "tag_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Remark",
      field: "remarks",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "File",
      field: "file_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              {params.data.file_or_url == "url" && (
                <a href={params.value} target="_blank">
                  Click Here
                </a>
              )}
              {params.data.file_or_url != "url" && (
                <a href={rpath + params.value} target="_blank">
                  Click Here
                </a>
              )}
            </div>
          );
        } else {
          return <div className="text-center">-</div>;
        }
      },
    },
  ];

  function repstatus(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Private?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Private",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "publish status icon in funder report list from Publish to Private for " +
              list.data.tag_name +
              " (" +
              list.data.resources_id +
              ") $$ " +
              trackobj.fundrepheading
          );
          funderreportpublish(
            localStorage.getItem("UID"),
            list.data.resources_id,
            2
          ).then((response) => {
            if (response.status === true) {
              listall(funid, urllink);
              toast.success(response.message);
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Publish?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Publish",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "publish status icon in funder report list from Private to Publish for " +
              list.data.tag_name +
              " (" +
              list.data.resources_id +
              ") $$ " +
              trackobj.fundrepheading
          );
          funderreportpublish(
            localStorage.getItem("UID"),
            list.data.resources_id,
            1
          ).then((response) => {
            if (response.status === true) {
              listall(funid, urllink);
              toast.success(response.message);
            }
          });
        }
      });
    }
  }

  function addlist(aid) {
    setRTitle("");
    setRDesc("");
    setRFile("");
    setRepId("");
    setRepId(aid.data.id);
    dotracking(
      "edit icon in funder report for " +
        aid.data.report_title +
        " (" +
        aid.data.id +
        ") $$ " +
        trackobj.fundrepheading
    );
    funderreportdetail(aid.data.id).then((res) => {
      if (res.status === true) {
        const fmt = res.data.report_details.file_name.split(".");
        setRepFormat(fmt[1]);
        setShow(true);
        setRTitle(res.data.report_details.report_title);
        setRDesc(res.data.report_details.report_description);
        if (res.data.report_details.file_name !== null) {
          setPUrl(res.data.file_path + res.data.report_details.file_name);
        }
      }
    });
  }
  const [urllink, setUrlLink] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    if (localStorage.getItem("Role") === "8") {
      funderprofile().then((res) => {
        if (res.status === true) {
          funderdetail(res.data.funder_id).then((res1) => {
            if (res1.status === true) {
              setFunName(res1.data.funders_details.funder_name);
            }
          });
          setFunId(res.data.funder_id);
          listall(res.data.funder_id, link[1]);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      setFunId(localStorage.getItem("UID"));
      listall(localStorage.getItem("UID"), link[1]);
    } else if (localStorage.getItem("Role") === "4") {
      schprofileview().then((res) => {
        if (res.status === true) {
          setFunId(res.data.school_id);
          listall(res.data.school_id, link[1]);
        }
      });
    } else {
      funderdetail(id).then((res) => {
        if (res.status === true) {
          setFunName(res.data.funders_details.funder_name);
          setFunId(id);
          listall(id, link[1]);
        }
      });
    }
  }, [window.location.href]);

  function listall(lid, ltype) {
    setFilterProduct([]);
    if (localStorage.getItem("Role") === "3") {
      managerreportlist(lid).then((res) => {
        if (res.status === true) {
          setRPath(res.data.file_path);
          if (ltype === "schoolreports") {
            setFilterProduct(res.data.school_reports);
          } else if (ltype === "funderreports") {
            setFilterProduct(res.data.funder_reports);
          }
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadreportlist(lid).then((res) => {
        if (res.status === true) {
          setRPath(res.data.file_path);
          setFilterProduct(res.data.school_reports);
        }
      });
    } else {
      funderreportlist(lid).then((res) => {
        if (res.status === true) {
          setRPath(res.data.file_path);
          setFilterProduct(res.data.funder_reports);
        }
      });
    }
  }

  const [cirerror, setCirError] = useState("");
  const [photourl, setPUrl] = useState("");
  function circfile(event) {
    setRFile("");
    setPUrl("");
    setCirError("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setRFile(event.target.files[0]);
        const fmt = event.target.files[0].name.split(".");
        setRepFormat(fmt[1]);
      } else {
        setCirError(
          "Upload File should be .jpg or .jpeg or .png or .pdf format"
        );
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setCirError("Image size should be less than 5MB");
      }
    }
  }

  const [show, setShow] = useState(false);
  function handleshow() {
    setRTitle("");
    setRDesc("");
    setCirError("");
    setPUrl("");
    setShow(true);
  }
  function handleclose() {
    setShow(false);
    setRTitle("");
    setRepId("");
    setRDesc("");
    setCirError("");
    setPUrl("");
  }
  const [errorMsg, setErrorMsg] = useState("");
  function repsubmit(e) {
    e.preventDefault();
    if (rtitle !== "") {
      if (rdesc !== "") {
        if (repid !== "") {
          const temp = new FormData();
          temp.append("reports_id", repid);
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("funder_id", funid);
          temp.append("description", rdesc);
          temp.append("title", rtitle);
          temp.append("funder_report_file", rfile);
          dotracking(
            "update buttion in funder report $$ ",
            trackobj.fundrepheading
          );
          funderreportupdate(temp).then((res) => {
            if (res.status === true) {
              handleclose();
              toast.success(res.message);
              listall(funid);
            }
          });
        } else {
          if (rfile !== "") {
            const temp = new FormData();
            temp.append("admin_id", localStorage.getItem("UID"));
            temp.append("funder_id", funid);
            temp.append("description", rdesc);
            temp.append("title", rtitle);
            temp.append("funder_report_file", rfile);
            dotracking(
              "submit buttion in funder report $$ ",
              trackobj.fundrepheading
            );
            funderreportcreate(temp).then((res) => {
              if (res.status === true) {
                handleclose();
                toast.success(res.message);
                listall(funid);
              }
            });
          } else {
            setErrorMsg("Please Upload File");
          }
        }
      } else {
        setErrorMsg("Please Enter Description");
      }
    } else {
      setErrorMsg("Please Enter Title");
    }
  }
  const navigate = useNavigate();
  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "back button in funder report for " +
          funname +
          " $$ " +
          trackobj.addfunderlist
      );
      navigate("/superadmin/funderlist");
    }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          {localStorage.getItem("Role") === "4" && (
            <h4 className="mb-0">CMS Report</h4>
          )}
          {localStorage.getItem("Role") === "3" &&
            urllink === "schoolreports" && (
              <h4 className="mb-0">School Report</h4>
            )}
          {localStorage.getItem("Role") === "3" &&
            urllink === "funderreports" && (
              <h4 className="mb-0">Funder Report</h4>
            )}
          {localStorage.getItem("Role") !== "3" &&
            localStorage.getItem("Role") !== "4" && (
              <h4 className="mb-0">Funder Report</h4>
            )}
        </div>
        {localStorage.getItem("Role") === "3" && (
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>CMS</a>
            </li>
            {urllink === "schoolreports" && (
              <li className="breadcrumb-item active" aria-current="page">
                School Report
              </li>
            )}
            {urllink === "funderreports" && (
              <li className="breadcrumb-item active" aria-current="page">
                Funder Report
              </li>
            )}
          </ol>
        )}
        {localStorage.getItem("Role") === "4" && (
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>CMS</a>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              CMS Report
            </li>
          </ol>
        )}
        {localStorage.getItem("Role") !== "3" &&
          localStorage.getItem("Role") !== "4" && (
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Funder</a>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                Funder Report
              </li>
            </ol>
          )}
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-9">
                  <h4>{funname}</h4>
                </div>
                <div className="col-md-3">
                  {localStorage.getItem("Role") !== "8" &&
                    localStorage.getItem("Role") !== "3" &&
                    localStorage.getItem("Role") !== "4" && (
                      <div className="text-right">
                        {/* <a className="btn btn-success me-2" onClick={handleshow}>
                        <i className="fa fa-plus"></i> Add Report
                      </a> */}
                        <a className="btn btn-gray" onClick={backlist}>
                          <i className="fe fe-corner-up-left"></i> Back
                        </a>
                      </div>
                    )}
                </div>
              </div>
              {localStorage.getItem("Role") !== "8" && (
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    suppressExcelExport={true}
                    suppressDragLeaveHidesColumns={true}
                    sortingOrder={["asc", "desc"]}
                  />
                </div>
              )}
              {localStorage.getItem("Role") === "8" && (
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnFDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    suppressExcelExport={true}
                    suppressDragLeaveHidesColumns={true}
                    sortingOrder={["asc", "desc"]}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>

      <Modal show={show} size="lg">
        <Modal.Header>
          {repid !== "" && <h4> Funder Report Detail</h4>}
          {repid === "" && <h4> Add Funder Report</h4>}
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="form-label">
                  Title <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={rtitle}
                  onChange={(e) => setRTitle(e.target.value)}
                />
              </div>
            </Col>

            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="form-label">
                  Description <span className="errortext"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Description"
                  value={rdesc}
                  onChange={(e) => setRDesc(e.target.value)}
                />
              </div>
            </Col>

            <Col lg={12} md={12}>
              <div className="form-group mb-3">
                <label className="form-label">
                  Upload File <span className="errortext"> *</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  onChange={circfile}
                  accept=".jpg,.jpeg,.png,.pdf"
                />

                {cirerror !== "" && (
                  <span className="errortext">{cirerror}</span>
                )}
              </div>

              {repformat === "pdf" && photourl !== "" && (
                <a href={photourl} target="_blank">
                  <img
                    style={{ width: "100px", height: "100px" }}
                    src={require("../../../../assets/images/pdf.png")}
                  />
                </a>
              )}
              {repformat !== "pdf" && photourl !== "" && (
                <a href={photourl} target="_blank">
                  <img
                    style={{ width: "100px", height: "100px" }}
                    src={photourl}
                  />
                </a>
              )}
            </Col>
            {errorMsg !== "" && <span className="errortext">{errorMsg}</span>}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {repid !== "" && (
            <a className="btn btn-success" onClick={repsubmit}>
              Update
            </a>
          )}
          {repid === "" && (
            <a className="btn btn-success" onClick={repsubmit}>
              Submit
            </a>
          )}

          <a className="btn btn-danger" onClick={handleclose}>
            Close
          </a>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
